import type { UserInfo } from '@qcdoc/shared/types/common/common.ts';

export interface MockSession {
  accessToken: string | null;
  expiresAt: string | null;
  user?: UserInfo | null;
  roles?: string[];
}

let readSession: () => MockSession = () => ({ accessToken: null, expiresAt: null });

export function configureSession(provider: () => MockSession): void {
  readSession = provider;
}

export const useAuthStore = { getState: (): MockSession => readSession() };